'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _PortfolioContributors = require('./PortfolioContributors.css');

var _PortfolioContributors2 = _interopRequireDefault(_PortfolioContributors);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactChartjs = require('react-chartjs');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _ = require('../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PortfolioContributors = (_dec = (0, _reactCssModules2.default)(_PortfolioContributors2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PortfolioContributors, _Component);

  function PortfolioContributors(props) {
    (0, _classCallCheck3.default)(this, PortfolioContributors);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PortfolioContributors.__proto__ || (0, _getPrototypeOf2.default)(PortfolioContributors)).call(this, props));

    _this.clickViewTooltip = function () {
      _this.setState({ viewTooltip: !_this.state.viewTooltip });
    };

    _this.clickCloseTooltip = function () {
      _this.setState({ viewTooltip: false });
    };

    _this.renderContributorsChart = function (Cs) {
      var chartOptions = {
        animation: false,
        responsive: true,
        maintainAspectRatio: false,
        scaleShowLabels: true,
        scaleShowGridLines: true,
        scaleShowVerticalLines: false,
        scaleShowHorizontalLines: true,
        showScale: true,
        scaleStartValue: 0
      };
      var c_company_names = Cs.map(function (c) {
        return _format2.default.longString(c.company_name);
      });
      var c_portfolio_weights = Cs.map(function (c) {
        return +parseFloat(c.portfolio_weight).toFixed(2);
      });
      var c_emission_weights = Cs.map(function (c) {
        return +parseFloat(c.emission_weight).toFixed(2);
      });
      var chartGray = '#D5D5D5';
      var chartRed = '#D2371B';
      var chartData = {
        labels: c_company_names,
        datasets: [{ label: 'Portfolio weight',
          fillColor: chartGray,
          strokeColor: chartGray,
          highlightFill: chartGray,
          highlightStroke: chartGray,
          data: c_portfolio_weights }, { label: 'Emissions weight',
          fillColor: chartRed,
          strokeColor: chartRed,
          highlightFill: chartRed,
          highlightStroke: chartRed,
          data: c_emission_weights }]
      };
      return _react2.default.createElement(
        _reactFlexboxGrid.Row,
        { styleName: 'portfolio-contributors-chart-wrap' },
        _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 0, sm: 1 }),
        _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, sm: 10, styleName: 'portfolio-contributors-chart' },
          _react2.default.createElement(_reactChartjs.Bar, { data: chartData, options: chartOptions })
        ),
        _react2.default.createElement(_reactFlexboxGrid.Col, { xs: 0, sm: 1 })
      );
    };

    _this.renderContributorsList = function (Cs) {
      return Cs.map(function (c, idx) {
        return _react2.default.createElement(
          'li',
          { key: c.company_name, styleName: 'holding' },
          _react2.default.createElement(
            'div',
            { styleName: 'holding-name' },
            idx + 1,
            '. ',
            c.company_name
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-asset' },
            _format2.default.perc(c.portfolio_weight / 100),
            ' of assets'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-invested' },
            _format2.default.perc(c.emission_weight / 100),
            ' of emissions'
          )
        );
      });
    };

    _this.state = {
      viewTooltip: false
    };
    return _this;
  }

  (0, _createClass3.default)(PortfolioContributors, [{
    key: 'render',
    value: function render() {
      function compare(a, b) {
        var a_weight = _convert2.default.float(a.portfolio_weight);
        var b_weight = _convert2.default.float(b.portfolio_weight);
        if (a_weight < b_weight) {
          return 1;
        }
        if (a_weight > b_weight) {
          return -1;
        }
        return 0;
      }
      var contributors = this.props.fund.portfoliocontributors.sort(compare);
      return _react2.default.createElement(
        'div',
        { styleName: 'portfolio-contributors' },
        _react2.default.createElement(
          'div',
          { styleName: 'portfolio-contributors-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'portfolio-contributors-title' },
            'Emissions of the top 10 fund holdings'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'portfolio-contributors-subtitle' },
            'Top 10 holdings, portfolio weight and emissions weight (Scope 1 + 2)'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'portfolio-contributors-chart-notice', onClick: this.clickViewTooltip },
            _react2.default.createElement('i', { className: 'fa fa-question-circle' }),
            ' What does this mean?'
          ),
          this.state.viewTooltip ? _react2.default.createElement(
            'div',
            { styleName: 'portfolio-contributors-chart-tooltip-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'portfolio-contributors-chart-tooltip-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'portfolio-contributors-chart-tooltip' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'portfolio-contributors-tooltip-close',
                    onClick: this.clickViewTooltip, title: 'Close' },
                  'Close',
                  _react2.default.createElement(_.LinkIcon, { faclass: 'fa-times' })
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'This chart shows the 10 largest holdings in this fund\'s portfolio. The grey bars represent the portfolio weight of each holding. The red bars track what percent of the funds\'s overall emissions are associated with each holding. If a company\'s red bar is higher than its gray bar, it means the holding is responsible for an outsized amount of this fund\'s carbon footprint. '
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'portfolio-contributors-detail-holdings-wrap' },
                  _react2.default.createElement(
                    'ul',
                    { styleName: 'detail-holdings' },
                    this.renderContributorsList(contributors)
                  )
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'Relative carbon footprint is measured in metric tonnes of CO',
                  _react2.default.createElement(
                    'sub',
                    null,
                    '2'
                  ),
                  ' or CO',
                  _react2.default.createElement(
                    'sub',
                    null,
                    '2'
                  ),
                  ' equivalents per $1 million USD invested'
                )
              )
            )
          ) : null,
          this.renderContributorsChart(contributors)
        ),
        this.state.viewTooltip ? _react2.default.createElement('div', { styleName: 'tooltip-overlay', onClick: this.clickCloseTooltip }) : null
      );
    }
  }]);
  return PortfolioContributors;
}(_react.Component), _class2.propTypes = {
  fund: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = PortfolioContributors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PortfolioContributors/PortfolioContributors.js
// module id = 1385
// module chunks = 0